import './culinary/style';
import FormStructure from './culinary/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /mnt/c/Users/Kevin.sheffield/Projects/inquiry-renderer/client_forms/includes.js